import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Alert } from "reactstrap";
import { useAccount } from "../../context/AccountContext";
import PageTitleAlt2 from "../../Layout/AppMain/PageTitleAlt2";
import { STRATEGY_OPTIONS } from "../../constants/strategies";
import TemplateCategoryBrowser from "../../components/rules/TemplateCategoryBrowser";

const RuleTemplatesPage = () => {
  const { selectedAccount } = useAccount();
  const history = useHistory();
  const [strategyType, setStrategyType] = useState("PYRAMID_HEDGING");
  const [importing, setImporting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleImport = async (selectedRules) => {
    if (!selectedRules.length || !selectedAccount) return;
    try {
      setImporting(true);
      setError(null);
      const res = await axios.post("/rules/import-template-rules", {
        username: selectedAccount,
        strategy_type: strategyType,
        rules: selectedRules
      });
      setSuccess(`Imported ${res.data.imported} rule(s). Redirecting to Rule Builder...`);
      setTimeout(() => history.push("/rules/builder"), 1500);
    } catch {
      setError("Failed to import selected rules.");
    } finally {
      setImporting(false);
    }
  };

  return (
    <>
      <PageTitleAlt2
        heading="Rule Templates"
        subheading="Browse rule categories and import only the individual rules you want."
        icon="pe-7s-albums icon-gradient bg-sunny-morning"
      />

      <div style={{ padding: "0 25px 25px" }}>
        {error && <Alert color="danger">{error}</Alert>}
        {success && <Alert color="success">{success}</Alert>}

        {/* Filter bar */}
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 20 }}>
          <select
            value={strategyType}
            onChange={e => { setStrategyType(e.target.value); setError(null); setSuccess(null); }}
            style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 13 }}
          >
            {STRATEGY_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>

          <button
            type="button"
            onClick={() => history.push("/rules/builder")}
            style={{
              padding: "8px 14px", borderRadius: 8, border: "1px solid #6c757d",
              background: "#fff", color: "#6c757d", fontSize: 13, cursor: "pointer",
            }}
          >
            Go to Rule Builder
          </button>
        </div>

        <TemplateCategoryBrowser
          strategyType={strategyType}
          onImport={handleImport}
          importing={importing}
        />
      </div>
    </>
  );
};

export default RuleTemplatesPage;
